import Vue from 'vue'
import ngVueComponentsModule from '@/angularBridge/ngVueComponentsModule'
import TaskEdit from '@/components/TaskEdit'
import taskTab from '@/components/taskTab'
import notification from '@/components/Notification'
import notificationCreate from '@/components/NotificationCreate'
import addOn from '@/components/AddOns'
import addOnListScreen from '@/components/AddOnListScreen'
import conversion from '@/components/Conversion'
import acordEmailHistory from '@/components/AcordEmailHistory'
import email from '@/components/Email'
import discount from '@/components/Discount'
import backOfficeHistory from '@/components/BackOfficeHistory'
import paymentMethod from '@/components/PaymentMethod'
import addOnSetUp from '@/components/AddOnSetUp'
import billNow from '@/components/BillNow'
import checkNumber from '@/components/CheckNumber'
import referralProgram from '@/components/ReferralProgram'
import financeContract from '@/components/FinanceContract'
import financeViewScreen from '@/components/FinanceViewScreen'
import WelcomeModal from '@/components/Home/WelcomeModal'
import financeTab from '@/components/FinanceTab.vue'
import contractAgreement from '@/components/FinanceContractAgreement'
import paymentSelection from '@/components/PaymentSelection'
import financeCompanySelection from '@/components/FinanceCompanySelection'
import financeCompanyPayment from '@/components/FinanceCompanyPayment'
import postPaymentModal from '@/components/PostPaymentModal'
import selectPrintingRange from '@/components/Benefits/SelectRange'
import contractError from '@/components/FinanceContractError'
import pettyCash from '@/components/PettyCash'
import policyMove from '@/components/PolicyMove'
import agencyBuzz from '@/components/AgencyBuzz'
import endorsement from '@/components/Finance/Endorsement'

ngVueComponentsModule.directive(
  'taskEdit',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('taskEdit')
      return createVueComponent(Vue.component('taskEdit', TaskEdit))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueTaskList',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('taskList')
      return createVueComponent(Vue.component('taskTab', taskTab))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueNotification',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('NotificationButton')
      return createVueComponent(Vue.component('Notification', notification))
    }
  ]
)

ngVueComponentsModule.directive(
  'notificationCreate',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('notificationCreate')
      return createVueComponent(Vue.component('notificationCreate', notificationCreate))
    }
  ]
)

ngVueComponentsModule.directive(
  'addOn',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('AddOn')
      return createVueComponent(Vue.component('AddOn', addOn))
    }
  ]
)

ngVueComponentsModule.directive(
  'addOnListScreen',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('addOnListScreen')
      return createVueComponent(Vue.component('addOnListScreen', addOnListScreen))
    }
  ]
)
ngVueComponentsModule.directive(
  'conversion',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('conversion')
      return createVueComponent(Vue.component('conversion', conversion))
    }
  ]
)
ngVueComponentsModule.directive(
  'acordEmailHistory',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('acordEmailHistory')
      return createVueComponent(Vue.component('acordEmailHistory', acordEmailHistory))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueEmail',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vueEmail')
      return createVueComponent(Vue.component('vueEmail', email))
    }
  ]
)

ngVueComponentsModule.directive(
  'discount',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('Discount')
      return createVueComponent(Vue.component('discount', discount))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueBackOfficeHistory',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vueBackOfficeHistory')
      return createVueComponent(Vue.component('vueBackOfficeHistory', backOfficeHistory))
    }
  ]
)

ngVueComponentsModule.directive(
  'vuePaymentMethod',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vuePaymentMethod')
      return createVueComponent(Vue.component('vuePaymentMethod', paymentMethod))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueAddOnSetUp',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vueAddOnSetUp')
      return createVueComponent(Vue.component('vueAddOnSetUp', addOnSetUp))
    }
  ]
)

ngVueComponentsModule.directive(
  'billNow',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('Bill Now')
      return createVueComponent(Vue.component('bill-now', billNow))
    }
  ]
)

ngVueComponentsModule.directive(
  'checkNumber',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('Check Number')
      return createVueComponent(Vue.component('check-number', checkNumber))
    }
  ]
)

ngVueComponentsModule.directive(
  'referralProgram',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('Referral Program')
      return createVueComponent(Vue.component('referralProgram', referralProgram))
    }
  ]
)

ngVueComponentsModule.directive(
  'welcomeScreen',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('Welcome Screen')
      return createVueComponent(Vue.component('welcome-screen', WelcomeModal))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueFinanceContract',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vueFinanceContract')
      return createVueComponent(Vue.component('vueFinanceContract', financeContract))
    }
  ]
)

ngVueComponentsModule.directive(
  'financeViewScreen',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('Finance View Screen')
      return createVueComponent(Vue.component('financeViewScreen', financeViewScreen))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueFinanceContract',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vueFinanceContract')
      return createVueComponent(Vue.component('vueFinanceContract', financeContract))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueFinanceList',
  [
    'createVueComponent',
    function (createVueComponent) {
      console.log('vueFinanceList')
      return createVueComponent(Vue.component('financeTab', financeTab))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueContractAgreement',
  [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('vueContractAgreement', contractAgreement))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueContractError',
  [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('vueContractError', contractError))
    }
  ]
)

ngVueComponentsModule.directive(
  'vuePaymentSelection',
  [
    'createVueComponent',
    function (createVueComponent) {
    return createVueComponent(Vue.component('vuePaymentSelection', paymentSelection))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueFinanceCompanySelection',
  [
    'createVueComponent',
    function (createVueComponent) {
    return createVueComponent(Vue.component('vueFinanceCompanySelection', financeCompanySelection))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueFinanceCompanyPayment',
  [
    'createVueComponent',
    function (createVueComponent) {
    return createVueComponent(Vue.component('vueFinanceCompanyPayment', financeCompanyPayment))
    }
  ]
)

ngVueComponentsModule.directive(
  'vuePostPaymentModal',
  [
    'createVueComponent',
    function (createVueComponent) {
    return createVueComponent(Vue.component('vuePostPaymentModal', postPaymentModal))
    }
  ]
)

ngVueComponentsModule.directive(
  'vueSelectRange',
  [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('vueSelectRange', selectPrintingRange))
    }
  ]
)

ngVueComponentsModule.directive(
  'pettyCash',
  [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('pettyCash', pettyCash))
    }
  ]
)

ngVueComponentsModule.directive(
  'policyMove',
  [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('policyMove', policyMove))
    }
  ]
)

ngVueComponentsModule.directive(
  'agencyBuzz',
  [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('agencyBuzz', agencyBuzz))
    }
  ]
)

ngVueComponentsModule.directive(
    'vueEndorsement',
    [
        'createVueComponent',
        function (createVueComponent) {
            return createVueComponent(Vue.component('endorsement', endorsement))
        }
    ]
)
